import { BaseResource } from '../core/base-resource';

export class ParkingSpot extends BaseResource {
  label: string;

  constructor() {
    super();
  }
}
